import React, {useEffect, useState} from 'react';
import {Typography} from "@material-tailwind/react";
import _ from "lodash";
import {check} from "./Check";

const Validator = ({state, rules, isChecked, showError = true}) => {
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasValidated, setHasValidated] = useState(false);

  // Reset validation when rules change
  useEffect(() => {
    setHasValidated(false);
    setError(false);
    setErrorMessage("");
  }, [rules]);

  useEffect(() => {
    // If isChecked is true, we should validate regardless of state
    if (isChecked) {
      setHasValidated(true);
      validateState();
    } else if (hasValidated) {
      // If we've validated before, keep validating as user types
      validateState();
    }
  }, [state, isChecked, rules]);

  const validateState = () => {
    // Handle empty/null state
    if (!state && state !== 0) { // Allow 0 as valid value
      if (rules.includes("required")) {
        setErrorMessage("این فیلد الزامی است");
        setError(true);
        return;
      } else {
        setError(false);
        setErrorMessage("");
        return;
      }
    }

    // For string values, check if they're empty after trim
    if (typeof state === 'string') {
      const trimmedState = state.trim();
      if (rules.includes("required") && trimmedState === "") {
        setErrorMessage("این فیلد الزامی است");
        setError(true);
        return;
      }
      
      // If field is optional and empty, no error
      if (!rules.includes("required") && trimmedState === "") {
        setError(false);
        setErrorMessage("");
        return;
      }
    }

    // Validate using the check function
    const ruleArray = _.split(rules, "|");
    let isError = false;
    let currentErrorMessage = "";

    for (let i = 0; i < ruleArray.length; i++) {
      const rule = ruleArray[i];
      const ruleParts = _.split(rule, "=");
      const ruleName = ruleParts[0];
      const ruleOptions = ruleParts[1] || null;

      // Create a temporary setErrorMessage function
      const tempSetErrorMessage = (msg) => {
        currentErrorMessage = msg;
      };

      if (!check(state, ruleName, ruleOptions, tempSetErrorMessage)) {
        isError = true;
        setErrorMessage(currentErrorMessage || "خطا در اطلاعات ورودی");
        break;
      }
    }
    
    setError(isError);
    if (!isError) {
      setErrorMessage("");
    }
  };

  // Don't render anything if we shouldn't show errors
  if (!showError) {
    return null;
  }

  // Don't show empty error messages
  if (!error || !errorMessage) {
    return null;
  }

  return (
    <Typography variant="small" color="red" className="mb-1">
      {errorMessage}
    </Typography>
  );
};

Validator.displayName = "Validator";

export default Validator;
